import Login from "../container/pages/Login";
import { SCREENS_IDS } from "./global-enums";
import Employees from "../views/Users/Employees/Employees";
import Users from "../views/Users/User/Users";
import Notifications from "../views/Users/Notification/Notifications";
import Dashboard from "../views/Users/Dashboard";
import Attendance from "../views/Users/Employees/Attendance";
import EmployeeAttendance from "../views/Users/Employees/EmployeeAttendance";
import PlatformDashboard from "../views/Platform/PlatformDashboard";
import Companies from "../views/Platform/Companies";

//Constants to set routes

const PublicRoutes = [
  {
    path: `/`,
    name: "login",
    component: Login,
  },
   {
    path: `/login`,
    name: "login",
    component: Login,
  },
];

const PrivateRoutes = [
  {
    screenId: SCREENS_IDS.DASHBOARD,
    path: `/dashboard`,
    name: "Dashboard",
    icon: "ri-dashboard-2-fill",
    sortOrder: "",
    component: Dashboard,
  },
  {
    screenId: SCREENS_IDS.USERS,
    path: `/users`,
    name: "Users",
    icon: "ri-group-fill",
    sortOrder: "",
    component: Users,
  },
  {
    screenId: SCREENS_IDS.EMPLOYEES,
    path: `/employees`,
    name: "Employees",
    icon: "ri-shield-user-fill",
    sortOrder: "",
    component: Employees,
  },
  {
    screenId: SCREENS_IDS.SETTINGS,
    path: `/settings`,
    name: "Notification Settings",
    icon: "ri-settings-3-fill",
    sortOrder: "",
    component: Notifications,
  },
  {
    screenId: SCREENS_IDS.ATTENDANCE,
    path: `/attendance`,
    name: "Attendance",
    icon: "ri-time-fill",
    sortOrder: "",
    component: Attendance ,
  },
  {
    screenId: SCREENS_IDS.EMPLOYEE_ATTENDANCE,
    path: `/employee-attendance`,
    name: "Attendance",
    icon: "ri-time-fill",
    sortOrder: "",
    component: EmployeeAttendance ,
  },
  {
    screenId: SCREENS_IDS.PLATFORM_DASHBOARD,
    path: `/platform-dashboard`,
    name: "Platform Dashboard",
    icon: "ri-dashboard-2-fill",
    sortOrder: "",
    component: PlatformDashboard,
  },
  {
    screenId: SCREENS_IDS.COMPANIES,
    path: `/companies`,
    name: "Companies",
    icon: "ri-building-fill",
    sortOrder: "",
    component: Companies,
  },
];

const RouteConfig = { PublicRoutes, PrivateRoutes };
export default RouteConfig;
